
// Google Analytics
import { Inject, Singleton } from '@denishussar/html5-game-engine';
import { FirebaseCloudDB } from '../CloudDB/FirebaseCloudDB';
import { GameAnalytics } from 'gameanalytics';
import { GameEvent } from '../../Constants/GameEvent';

@Singleton
export class GoogleAnalyticsService {
    constructor(@Inject private temporaryProvider: FirebaseCloudDB) {
        if (window['__DISABLE_ANALYTICS__']) return;
        if (location.hostname === 'localhost') return;
        if (location.hostname === '0.0.0.0') return;
        GameAnalytics.setEnabledInfoLog(true);
        GameAnalytics.initialize('9368225468c6b41a1a79f8727d599d52', '43bf862a82c78a18a91d0e375684c8589a474845');
    }

    sendEvent(eventName: GameEvent, eventParams: object = {}) {
        if (window['__DISABLE_ANALYTICS__']) return;
        if (location.hostname === 'localhost') return;
        if (location.hostname === '0.0.0.0') return;
        this.temporaryProvider.logEvent(eventName, eventParams);
    }

    sendEventPage(pageName: string, eventParams: object = {}) {
        //this.temporaryProvider.logEventPage(pageName, eventParams);
    }
}
